module.exports = __webpack_public_path__ + "img/poak-fc.d4a3d1de.png";